import { APICore } from './apiCore'

const api = new APICore()

function getDictionary (params) {
  const baseUrl = '/languages'
  return api.get(baseUrl, params)
}

function addDictionary (params) {
  const baseUrl = '/languages'
  return api.create(baseUrl, params)
}

// function updateDictionary (params) {
//   const baseUrl = '/languages'
//   return api.update(baseUrl, params)
// }

export { getDictionary, addDictionary }
